import React from "react";

const ModuleRow = ({ module, i, orderHistory }) => {

  const count =
    orderHistory?.moduleCountMap?.[module?.id] || 0;

  return (
    <div key={i}>
      <div className="breakdown-item">
        <span className="item-name">{module?.name}</span>
        <span className="item-count">{count}</span>
      </div>
    </div>
  );
};

export default ModuleRow;